import styled from 'styled-components';
import { Banner as Banner_, Buttons, FlexContainer } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: 1rem;
  border-radius: 14px;
  height: 100%;
`;

export const WizardBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 1rem;
  width: 100%;
  max-width: 450px;
  margin-bottom: 24px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  max-width: 450px;
`;

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    display: grid;
    grid-template-columns: 3fr;
    grid-column-gap: 30px;
    padding: 30px;
    height: 100%;
  }
`;

export const Banner = styled(Banner_)`
  width: 100%;
  margin-bottom: 10px;
`;

export const ButtonsContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  margin-top: 10px;
  label {
    font-weight: 450;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ButtonsActions = styled(Buttons.Classic)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
`;
